import Vue from 'vue';
import VueRichTextRenderer from '@marvr/storyblok-rich-text-vue-renderer';
import RichText from '@/components/storyblok/RichText.vue';

Vue.use(VueRichTextRenderer, {
  resolvers: {
    components: {
      RichText,
    },
  },
});
